module.exports = __webpack_public_path__ + "img/banner_m.b1dbfe3.png";